/** `useSyncExternalStore` subscribe for a browser value that fires no change event. */
export const subscribeToNothing = () => () => {};
